module.exports = __webpack_public_path__ + "static/media/Artboard9.50731b54.png";